import React from 'react'

type CheckboxGroupProps = {
    label: string
    required?: boolean
    options: Array<{ id: string | number; label: string }>
    selectedValues: Array<string | number>
    onChange: (value: string | number) => void
    columns?: 1 | 2 | 3
    maxHeight?: string
    bordered?: boolean
    loading?: boolean
    loadingMessage?: string
    className?: string
}

export const CheckboxGroup = (props: CheckboxGroupProps) => {
    const {
        label,
        required = false,
        options,
        selectedValues,
        onChange,
        columns = 2,
        maxHeight = 'max-h-48',
        bordered = true,
        loading = false,
        loadingMessage = 'Loading...',
        className = ''
    } = props

    const gridCols = {
        1: 'grid-cols-1',
        2: 'grid-cols-1 sm:grid-cols-2',
        3: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3'
    }

    const containerClasses = bordered
        ? `border border-gray-300 dark:border-gray-600 rounded-md p-3 bg-gray-50 dark:bg-gray-800`
        : ''

    return (
        <div className={className}>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                {label}
                {required && <span className="text-danger-600 ms-1">*</span>}
            </label>
            <div className={`grid ${gridCols[columns]} ${maxHeight} overflow-y-auto ${containerClasses}`}>
                {loading || options.length === 0 ? (
                    <p className="col-span-full text-sm text-gray-500 dark:text-gray-400 italic py-2">
                        {loadingMessage}
                    </p>
                ) : (
                    options.map((option) => (
                        <label
                            key={option.id}
                            className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded transition-colors min-h-9"
                        >
                            <input
                                type="checkbox"
                                checked={selectedValues.includes(option.id)}
                                onChange={() => onChange(option.id)}
                                className="h-4 w-4 text-primary-500 border-gray-300 rounded focus:ring-primary-500 flex-shrink-0"
                            />
                            <span className="text-sm text-gray-700 dark:text-gray-300 leading-tight">
                                {option.label}
                            </span>
                        </label>
                    ))
                )}
            </div>
        </div>
    )
}
